import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faUser, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Header from '../Header';
import {
  Button, Table, Alert, Spinner, Card,
  Container, Row, Col, Pagination
} from 'react-bootstrap';
import './index.css';

const DeleteLeads = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const leadsPerPage = 5;

  useEffect(() => {
    fetch('https://apiaksharaconnect.aksharafinalytics.in/archivedLeads')
      .then(res => {
        if (!res.ok) {
          throw new Error('Failed to fetch leads');
        }
        return res.json();
      })
      .then(data => {
        if (data.archivedLeads) {
          setLeads(data.archivedLeads);
        } else {
          setError('No leads found');
        }
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  const indexOfLastLead = currentPage * leadsPerPage;
  const indexOfFirstLead = indexOfLastLead - leadsPerPage;
  const currentLeads = leads.slice(indexOfFirstLead, indexOfLastLead);
  const totalPages = Math.ceil(leads.length / leadsPerPage);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString();
  };

  const handleAction = (action, id) => {
    alert(`Action: ${action}, ID: ${id}`);
  };

  if (loading) {
    return <div className="text-center mt-5"><Spinner animation="border" variant="primary" /></div>;
  }

  return (
    <>
      <Header />
      <Container fluid className="shadow mx-1 px-3 bg-light rounded-3">
        <Row className="d-flex align-items-center justify-content-between p-3 mt-3">
          <Col><h4 className="mb-0">Deleted Leads</h4></Col>
        </Row>

        {error && <Alert variant="danger">{error}</Alert>}

        <Card>
          <Card.Header>Lead List</Card.Header>
          <Card.Body>
            <Table bordered hover responsive>
              <thead>
                <tr>
                  <th>S.no</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Source</th>
                  <th>Lead By</th>
                  <th>Remarks</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {currentLeads.length > 0 ? currentLeads.map((lead, index) => (
                  <tr key={lead.id}>
                    <td>{indexOfFirstLead + index + 1}</td>
                    <td>{lead.name || 'N/A'}</td>
                    <td>{lead.email || 'N/A'}</td>
                    <td>{lead.phone || 'N/A'}</td>
                    <td>{lead.source || 'N/A'}</td>
                    <td>{lead.leadby || 'N/A'}</td>
                    <td>{lead.remarks || 'N/A'}</td>
                    <td>{formatDate(lead.lead_date)}</td>
                  </tr>
                )) : (
                  <tr><td colSpan="10">No leads available</td></tr>
                )}
              </tbody>
            </Table>

            {totalPages > 1 && (
              <Pagination className="justify-content-center mt-3">
                <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                {[...Array(totalPages)].map((_, idx) => (
                  <Pagination.Item
                    key={idx + 1}
                    active={currentPage === idx + 1}
                    onClick={() => setCurrentPage(idx + 1)}
                  >
                    {idx + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
              </Pagination>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default DeleteLeads;
